import {environment} from "src/app/environments/environment";
import versionFile from "../../public/versionFile.json";

export const appVersion = `${versionFile.version}-${environment.platform}`

export const verifier = "06738347328:87384739203"
